const dashboardTypes = {
  FETCH_DASHBOARD_START: 'FETCH_DASHBOARD_START',
  SET_LOADING_DASHBOARD: 'SET_LOADING_DASHBOARD',
  SET_DASHBOARD_DATA: 'SET_DASHBOARD_DATA',
  FETCH_DASHBOARD_CHART_START: 'FETCH_DASHBOARD_CHART_START',
  SET_LOADING_DASHBOARD_CHART: 'SET_LOADING_DASHBOARD_CHART',
  SET_DASHBOARD_CHART_DATA: 'SET_DASHBOARD_CHART_DATA',
};

export default dashboardTypes;
